/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import cx from 'classnames';
import {useContext} from 'react';
import {useSelector} from 'react-redux';
import {Box} from '~/CreateFabricInvitation/components/Box/Box';
import {EditorGroup} from '~/CreateFabricInvitation/components/EditorGroup/EditorGroup';
import {EditorHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorHeader';
import {TextColorPicker} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/ColorPicker/TextColorPicker';
import {Dropdown} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/Dropdown';
import {LetterSpacing} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/LetterSpacing/LetterSpacing';
import {LineHeight} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/LineHeight/LineHeight';
import {ResetStyle} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/ResetStyle/ResetStyle';
import {TextFormat} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/TextFormat/TextFormat';
import {TextSize} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/TextSize/TextSize';
import {TextEditor} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/Desktop/TextEditor/TextEditor';
import {EditBox} from '~/common/FabricInvitation/EventCreateDesign/components/EditBox/EditBox';
import {menuMappingKeys} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {selectTouched} from '~/common/fabric/reducers/fabricDesign/selectors';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

import './CardEditorDesktop.sass';

export const CardEditorDesktop = () => {
  const {activeObjects} = useContext(EventCreateContext);
  const touched = useSelector(selectTouched);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;

  if (!touched || isMobile) {
    return null;
  }

  return (
    <div
      className={cx({
        card_editor: true,
        'card_editor--disabled': !activeObjects?.length,
      })}
    >
      <EditBox className="card_editor__content">
        <TextEditor />
        <EditorGroup>
          <EditorHeader
            title="Text Style"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.FONT_STYLE}
                dataQaId="step1-textstyle-reset"
              />
            }
          />
          <Dropdown />
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Text Size"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.FONT_SIZE}
                dataQaId="step1-textsize-reset"
              />
            }
          />
          <TextSize />
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Text Color"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.COLOR}
                dataQaId="step1-textcolor-reset"
              />
            }
          />
          <Box height="10rem">
            <TextColorPicker showAll />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Text Format"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.TEXT_FORMAT}
                dataQaId="step1-textformat-reset"
              />
            }
          />
          <Box>
            <TextFormat />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Spacing"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.SPACING}
                dataQaId="step1-textspacing-reset"
              />
            }
          />
          <Box>
            <EditorHeader title="Letter Spacing" dark />
            <LetterSpacing />

            <EditorHeader title="Line Height" dark />
            <LineHeight />
          </Box>
        </EditorGroup>
      </EditBox>
    </div>
  );
};
